import { render, staticRenderFns } from "./videoGuides.vue?vue&type=template&id=88c03160&scoped=true"
import script from "./videoGuides.vue?vue&type=script&lang=js"
export * from "./videoGuides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c03160",
  null
  
)

export default component.exports